import { useTranslation } from "../../../../language";

export default function SubSubText() {
  const { t } = useTranslation();
  return <span>{t("sub_subtext")}</span>;
}
